import React from 'react';
import {createRoot} from 'react-dom/client';
import PricingComparisonTable from '../../components/PricingComparisonTable';

let root = null;

window.PricingComparisonTable = {
    init() {
        const container = document.getElementById('pricing-comparison-table-root');
        const dataEl = document.getElementById('pricing-comparison-data');
        if (!container || !dataEl) {
            return;
        }

        let comparison;
        try {
            comparison = JSON.parse(dataEl.textContent);
        } catch (e) {
            window.sentry?.captureException(e);
            return;
        }

        root = createRoot(container);
        root.render(
            <PricingComparisonTable
                comparison={comparison}
                exportUrl={window.pricingComparisonExportUrl}
                i18n={window.pricingComparisonI18n || {}}
            />
        );
    },

    destroy() {
        if (root) {
            try {
                root.unmount();
            } catch (e) {
                console.warn('PricingComparisonTable: unmount failed', e);
            }
        }
        root = null;
    }
};
